export default "__VITE_ASSET__BPhd51cG__"